module.exports = __webpack_public_path__ + "static/media/paint-brush.532f1a84.svg";